import React, {useEffect} from "react";
import {connect} from "react-redux";
import {Dialog, DialogTitle, DialogContent, CircularProgress, Typography, Box, Stack, Paper} from "@mui/material";
import {campaignsActions} from "../../../../modules/campaigns/campaigns.actions.js";
import {ArcherContainer, ArcherElement} from "react-archer";
import {helper} from "../../../../utils/helper.js";
import {useNavigate} from "react-router-dom";
import Constants from "../../../../utils/constants.js";

function DashboardModalDetailsWorkDone({open, onClose, date, tourneeId, dispatch, onlyShowImpossible, details, loading, error}) {
    const navigate = useNavigate();

    useEffect(() => {
        if (open && date && tourneeId) {
            dispatch(campaignsActions.fetchDetails(date, tourneeId));
        }
    }, [open, date, tourneeId, dispatch]);

    // Couleur = état dominant calculé par l'API (InterventionStatusResolver, INT-02) : même verdict que la
    // fiche intervention. Le lavage partiel est un lavage (vert), le graffiti seul ne change pas l'état.
    const getStatutBgColor = (data) => {
        switch (data?.etat) {
            case 'LAVAGE_IMPOSSIBLE':
                return {backgroundColor: "#B22222", color: "white"};
            case 'LAVE_MAINTENANCE':
                return {backgroundColor: "#e67e22", color: "white"};
            default:
                return {backgroundColor: "#7bb421"};
        }
    }

    const filteredOrdreReel = onlyShowImpossible
        ? details?.ordreReel.filter(c => c.etat === 'LAVAGE_IMPOSSIBLE')
        : details?.ordreReel;

    const filteredOrdrePrevu = onlyShowImpossible
        ? details?.ordrePrevu.filter(c => filteredOrdreReel?.some(r => r.id === c.id))
        : details?.ordrePrevu;


    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            {/*<DialogTitle>Détail du travail réalisé</DialogTitle>*/}
            <DialogContent>
                {loading && <CircularProgress/>}
                {error && <Typography color="error">Erreur : {JSON.stringify(error)}</Typography>}
                {!loading && !error && details && (
                    <>
                        <Paper sx={{padding: 2, maxHeight: '85vh', overflow: 'auto'}}>
                            <Typography variant="h6" gutterBottom textAlign={"center"}>
                                {onlyShowImpossible ? "Lavages impossibles" : "Comparaison de la tournée"}
                            </Typography>
                            <ArcherContainer strokeColor="#1976d2">
                                <Stack direction="row" spacing={6} sx={{width: "100%"}}>
                                    {/* Ordre prévu */}
                                    <Stack spacing={2} sx={{width: "50%"}}>
                                        <Typography variant="subtitle1" textAlign={"center"}>Ordre prévu</Typography>
                                        {filteredOrdrePrevu.map((c, i) => (
                                            <ArcherElement
                                                key={`planned-${c.id}`}
                                                id={`planned-${c.id}`}
                                                relations={(() => {
                                                    const realIndex = details?.ordreReel.findIndex(a => a.id === c.id);
                                                    if (realIndex === -1) return [];

                                                    const isSamePosition = realIndex === i;

                                                    return [{
                                                        targetId: `actual-${c.id}`,
                                                        targetAnchor: 'left',
                                                        sourceAnchor: 'right',
                                                        style: {
                                                            strokeColor: isSamePosition ? '#1976d2' : '#FF0000', // bleu si ok, rouge si ordre changé
                                                            strokeWidth: 2
                                                        }
                                                    }];
                                                })()}
                                            >
                                                <Box sx={{
                                                    border: '1px solid #ccc',
                                                    padding: 1,
                                                    borderRadius: 1,
                                                    width: '65%',
                                                    alignSelf: "start",
                                                    backgroundColor: '#f9f9f9'
                                                }}>
                                                    <Typography variant="body2">{i + 1}. {c.nomenclature}</Typography>
                                                    <Typography variant="caption">{c.adresse}</Typography>
                                                </Box>
                                            </ArcherElement>
                                        ))}
                                    </Stack>

                                    {/* Ordre réalisé */}
                                    <Stack spacing={2} sx={{width: "50%", cursor: "pointer"}}>
                                        <Typography variant="subtitle1" textAlign={"center"}>Ordre réalisé</Typography>
                                        {filteredOrdreReel.map((c, i) => (
                                            <ArcherElement key={`actual-${c.interventionId}`} id={`actual-${c.id}`}>
                                                <Box sx={{
                                                    border: '1px solid #ccc',
                                                    width: '65%',
                                                    alignSelf: "end",
                                                    padding: 1,
                                                    borderRadius: 1, ...getStatutBgColor(c)
                                                }}
                                                     onClick={() => {
                                                         navigate(Constants.APP_ROUTE_INTERVENTIONS.replace(":id", c.id))
                                                     }}
                                                >
                                                    <Typography
                                                        variant="body2">{i + 1}. {c.nomenclature} - {helper.getFormattedTime(c.dateEvenement)}</Typography>
                                                    <Typography variant="caption">{c.adresse}</Typography>
                                                    {c.signalements?.map((s, k) => (
                                                        <Typography key={k} variant="caption"
                                                                    sx={{display: "block", fontWeight: 600}}>
                                                            • {s}
                                                        </Typography>
                                                    ))}
                                                </Box>
                                            </ArcherElement>
                                        ))}
                                    </Stack>
                                </Stack>
                            </ArcherContainer>
                        </Paper>
                    </>
                )}
            </DialogContent>
        </Dialog>
    );
}

const mapStateToProps = state => ({
    details: state.campaigns.details,
    loading: state.campaigns.detailsLoading,
    error: state.campaigns.detailsError,
});

export default connect(mapStateToProps)(DashboardModalDetailsWorkDone);
